module.exports = __webpack_public_path__ + "images/jsw-crossflow/intercom.42d7dae798b0ed628cd4.png";